import { Record } from 'immutable';
import BaseStore from './BaseStore';
import { ActionTypes } from '../constants/AppConstants';
import ConsentsForm, { defaultConsents } from '../records/customer/ConsentsForm';

const State = new Record({
    form: new ConsentsForm(),
    response: {},
    template: {},
    isLoading: false,
});

class ConsentsStore extends BaseStore {
    deserialize(serialized) {
        if (serialized) {
            const { form, response, template } = serialized;
            return new State({
                form: form instanceof ConsentsForm ? form : new ConsentsForm(form || {}),
                response: response || {},
                template: template || {},
            });
        }
        return new State();
    }

    get form() {
        return this.state.form;
    }

    getInitialState() {
        return new State();
    }

    handleConsentsLoaded({ consents }) {
        this.setState(this.state.set('response', consents));
    }

    handleTemplateLoaded({ consents }) {
        this.setState(this.state.set('template', consents));
    }

    setConsentsForm({ payload }) {
        this.setState(this.state.set('form', this.state.form.merge(payload)));
    }

    handleGetTemplateStarted() {
        this.setState(this.state
            .set('form', this.state.form.merge(defaultConsents))
            .set('isLoading', true)
        );
    }

    setIsLoading(value) {
        return function() {
            this.setState(this.state.set('isLoading', value));
        };
    }

    getActionHandlers() {
        return {
            [ActionTypes.GET_USER_CONSENTS_SUCCESS]: this.handleConsentsLoaded,
            [ActionTypes.GET_CONSENTS_TEMPLATE_SUCCESS]: this.handleTemplateLoaded,
            [ActionTypes.SET_CONSENTS_FORM]: this.setConsentsForm,
            [ActionTypes.GET_CONSENTS_TEMPLATE_STARTED]: this.handleGetTemplateStarted,
            [ActionTypes.GET_USER_CONSENTS_STARTED]: this.setIsLoading(true),
            [ActionTypes.GET_CONSENTS_TEMPLATE_FINISHED]: this.setIsLoading(false),
            [ActionTypes.GET_USER_CONSENTS_FINISHED]: this.setIsLoading(false),
        };
    }
}

const instance = new ConsentsStore({ storageKey: 'consents' });

export default instance;
